// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3Vot9","label":"Completed_label__1qABx"};